module.exports = __webpack_public_path__ + "static/media/legacy_logo.47c5ff3f.png";